import { IComputedValue, IObservableValue } from "mobx";
import { createContext } from "react";
import { ActivePaneState, Pane } from "../Types";

export type PaneComponentContext = {
  paneComputed: IComputedValue<Pane | undefined>;
  activePaneState: ActivePaneState;
  showPaneBodyOnCollapsedPaneBox: IObservableValue<boolean>;
};

export const PaneComponentContext = createContext<PaneComponentContext>(
  undefined as any
);
